import { useGetTradingAccount } from "./useGetAccount";
import useGetOwners from "./useGetOwners";

export const useGetIsLegalEntity = () => {
  // TODO (MLA): We need to re-evaluate usage of this hook when we
  // progress through the later stages of the MLA project.
  //
  // e.g., is it possible for the logged in user identity to have access to
  // a primary legal entity owned account and a non-entity account?
  const { account } = useGetTradingAccount();

  const { owners, isLoading } = useGetOwners({
    accountId: account?.id ?? "",
    options: { enabled: !!account?.id },
  });

  const primaryOwner = owners?.find((owner) => owner?.primary === true);
  const isLegalEntity = primaryOwner?.is_legal_entity ?? false;

  return {
    isLegalEntity,
    isLegalEntityLoading: isLoading,
  };
};
